import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Nets } from 'static/images/logos/payments/nets.svg';

function NetsComponents({ white }) {
  return (
    <Root white={white}>
      <Nets />
    </Root>
  );
}

export default NetsComponents;

const Root = styled.div`
  svg {
    .letters,
    .circles {
      fill: ${({ theme }) => theme.colors.secondary.default};
    }

    .circles {
      opacity: 0.5;
    }

    ${({ white }) =>
      white &&
      `
      .letters,
      .circles {
        fill: white;
        opacity: 0.5;
      }

      .circles {
        opacity: 0.3;
      }
    `}
  }
`;
